import React from 'react';
import styles from '../components/Layout/Navbar/styles.module.scss';

const LogoAurentum = () => (
  <img src='/logo-aurentum.svg' alt='aurentum-logo' className={styles.logo} />
);

export default LogoAurentum;
